(function ($) {
  "use strict";

  // 必要枚数自動計算フォーム
  // ------------------------------------------------------------
  // このスクリプトの役割:
  // 1) URLとDOM条件に一致する商品ページでフォームを表示
  // 2) 入力値（横幅・奥行き）から必要枚数を計算
  // 3) 結果/エラーを画面に表示
  //
  // よく編集する場所:
  // - 対象商品の追加/削除: config.productSettings
  // - 文言変更: config.defaultNoticeSettings / config.errorMessages
  // ------------------------------------------------------------
  var SheetQtyCalc = {
    config: {
      debug: true,

      // フォーム上下のデフォルト注意書き
      defaultNoticeSettings: {
        notice_before_form: "必要枚数の目安を知りたい方は、以下のフォームにお部屋のサイズを入力してください。",
        notice_after_form: "・表示枚数は、お部屋の端から順に敷いた場合の目安枚数です。<br>・壁際などでカットして余った端材の、反対側や別の列での再利用は考慮していません。<br>・敷き方や切り損じ等により、実際に必要な枚数は増減する場合があります。不足が心配な場合は予備分を含めてご購入ください。",
      },

      // 入力不備や計算失敗時の表示文言
      errorMessages: {
        invalid_input: "幅と奥行きの両方に1以上の数値を入れてください。",
        calculation_error: "計算中にエラーが発生しました。サイトにお問い合わせください。",
      },

      // 商品ごとの表示設定
      // - url_contains: 現在URLにこの文字列が含まれると候補になる
      // - product_base_selector: 商品名や「カートに入れる」ボタンなどの商品情報がまとまっている要素のセレクタ（任意）。指定すると「カートに戻る」ボタンが表示される。
      // - scroll_button_position_selector: 「枚数目安計算ツールへ」ボタンの挿入先セレクタ（任意）。指定すると「枚数目安計算ツールへ」ボタンが表示される。
      // - scroll_button_insert_method:  「枚数目安計算ツールへ」ボタンの挿入方法。before / after / prepend / append
      // - tool_position_selector: ツール挿入先要素のセレクタ。指定した要素が存在しないとツールは表示されない。
      // - tool_insert_method: ツールの挿入方法。before / after / prepend / append
      // - product_width, product_depth: 1枚あたりのサイズ(cm)
      productSettings: [
        {
          url_contains: "products/81955980",
          product_base_selector: ".products-base_data",
          scroll_button_position_selector: ".products-base_data",
          scroll_button_insert_method: "after",
          tool_position_selector: "h3.qty-form-header",
          tool_insert_method: "after",
          form_title: "「置くだけ ウッド調 フロアタイル」の必要枚数の目安を計算できます。",
          notice_before_form: "",
          notice_after_form: "",
          product_width: 91.4,
          product_depth: 15.2,
        },
        {
          url_contains: "products/81965710",
          product_base_selector: ".products-base_data",
          scroll_button_position_selector: ".products-base_data",
          scroll_button_insert_method: "after",
          tool_position_selector: "h3.qty-form-header",
          tool_insert_method: "after",
          form_title: "「ストーン調フロアタイル」の必要枚数の目安を計算できます。",
          notice_before_form: "",
          notice_after_form: "",
          product_width: 30.5,
          product_depth: 30.5,
        },
        {
          url_contains: "products/81970130",
          product_base_selector: ".products-base_data",
          scroll_button_position_selector: ".products-base_data",
          scroll_button_insert_method: "after",
          tool_position_selector: "h3.qty-form-header",
          tool_insert_method: "after",
          form_title: "「超薄型フロアタイル」の必要枚数の目安を計算できます。",
          notice_before_form: "",
          notice_after_form: "",
          product_width: 30,
          product_depth: 60,
        },
        {
          url_contains: "products/270623500",
          product_base_selector: ".products-base_data",
          scroll_button_position_selector: ".products-base_data",
          scroll_button_insert_method: "after",
          tool_position_selector: "h3.qty-form-header",
          tool_insert_method: "after",
          form_title: "「タイルカーペット」の必要枚数の目安を計算できます。",
          notice_before_form: "",
          notice_after_form: "",
          product_width: 40,
          product_depth: 40,
        },
        {
          url_contains: "products/159067200",
          product_base_selector: ".products-base_data",
          scroll_button_position_selector: ".products-base_data",
          scroll_button_insert_method: "after",
          tool_position_selector: "h3.qty-form-header",
          tool_insert_method: "after",
          form_title: "「カットできる紙製薄畳 樹」の枚数の目安を計算できます。",
          notice_before_form: "",
          notice_after_form: "",
          product_width: 82,
          product_depth: 82,
        },
      ],
    },

    /**
     * 初期化エントリポイント。
     * DOM構築完了後に bootstrap を呼び出して、
     * 表示対象判定とフォーム挿入を開始する。
     */
    init: function () {
      var self = this;

      // DOM読み込み後に初期化
      $(document).ready(function () {
        self.bootstrap();
      });
    },

    /**
     * デバッグログ出力。
     * config.debug が true のときだけ console へ出力する。
     * 本番で不要なログを出さないためのラッパー。
     */
    log: function () {
      if (this.config.debug && console && console.log) {
        console.log.apply(console, ["[SheetQtyCalc]"].concat(Array.prototype.slice.call(arguments)));
      }
    },

    /**
     * 起動時のメイン処理。
     * 1) 現在ページに合う設定を1件取得
     * 2) 多重挿入を防止
     * 3) フォーム挿入とイベント登録
     */
    bootstrap: function () {
      // 現在ページに一致する設定を1件探す（先に見つかった1件を採用）
      var match = this.findMatchedSetting();

      if (!match || !match.$toolTarget || match.$toolTarget.length === 0) {
        this.log("対象設定なし、または挿入先なし");
        return;
      }

      if (this.isAlreadyInserted(match.$toolTarget)) {
        this.log("フォームは既に挿入済み");
        return;
      }

      this.insertForm(match.setting, match.$toolTarget);
      this.insertScrollButton(match.setting, match.$buttonTarget);

      // 動的に追加したフォームにも反応するよう、イベント委譲でバインド
      this.bindEvents();
      this.log("フォーム挿入完了");
    },

    /**
     * 現在ページに一致する商品設定を検索する。
     * 一致条件:
     * - window.location.href に url_contains が含まれる
     * - tool_position_selector で指定した要素が存在する
     * - scroll_button_position_selector は確認しない（フォーム挿入とは別の場所にボタンを出すため）
     *
     * @returns {Object|null}
     *   一致時: { setting: Object, $toolTarget: jQueryObject, $buttonTarget: jQueryObject }
     *   非一致時: null
     */
    findMatchedSetting: function () {
      var i;
      var settings = this.config.productSettings;
      var href = window.location.href || "";

      for (i = 0; i < settings.length; i += 1) {
        var setting = settings[i];

        // 条件1: URL一致
        var isUrlMatched = href.indexOf(setting.url_contains) !== -1;

        if (!isUrlMatched) {
          continue;
        }

        // 条件2: 挿入先要素の存在
        var $toolTarget = $(setting.tool_position_selector).first();
        if ($toolTarget.length === 0) {
          continue;
        }

        // オプション：ボタン挿入位置の存在（必須ではない）
        var $buttonTarget = $(setting.scroll_button_position_selector).first();
        if ($buttonTarget.length === 0) {
          $buttonTarget = null;
        }

        return {
          setting: setting,
          $toolTarget: $toolTarget,
          $buttonTarget: $buttonTarget,
        };
      }

      return null;
    },

    /**
     * フォームの二重挿入を防止するためのチェック。
     * 同じ親スコープ内に既存フォーム(class: js-sheet-qty-calc)があるか確認する。
     *
     * @param {jQuery} $target 挿入対象要素
     * @returns {boolean} 既に挿入済みなら true
     */
    isAlreadyInserted: function ($target) {
      // 同じ場所に多重挿入しないためのガード
      var $scope = $target.parent();
      return $scope.find(".js-sheet-qty-calc").length > 0;
    },

    /**
     * 「枚数目安計算ツールへ」を指定位置に挿入する
     * 挿入方法は setting.insert_method で切り替える。
     * before: $target の前に挿入
     * after: $target の後ろに挿入
     * prepend: $target の最初の子要素として挿入
     * append: $target の最後の子要素として挿入
     * 未指定・不正値は after として扱う
     *
     * @param {Object} setting 商品設定
     * @param {jQuery} $target 挿入基準となる要素
     */
    insertScrollButton: function (setting, $target) {
      var buttonHtml = "";
      var method = setting.scroll_button_insert_method;

      buttonHtml += '<div class="sheet-qty-calc__scroll-to-tool-btn">';
      buttonHtml += '<div class="sheet-qty-calc__scroll-to-tool-btn-header">枚数でお悩みの方に！</div>';
      buttonHtml += '<button type="button" class="more xtAc js-sheet-qty-calc-scroll-to-tool-btn">';
      buttonHtml += "枚数自動計算ツールはこちら";
      buttonHtml += "</button>";
      buttonHtml += "</div>";

      if (!$target || $target.length === 0 || $target[0] === undefined || $target[0] === null) {
        this.log("挿入対象が見つからないため、スクロールボタン挿入をスキップ");
        return;
      }

      // 設定された挿入方法でボタンを配置
      if (method === "before") {
        $target.before(buttonHtml);
      } else if (method === "after") {
        $target.after(buttonHtml);
      } else if (method === "prepend") {
        $target.prepend(buttonHtml);
      } else if (method === "append") {
        $target.append(buttonHtml);
      } else {
        $target.after(buttonHtml);
      }
    },

    /**
     * フォームHTMLを指定位置へ挿入する。
     * insert_method によって挿入方法を切り替える。
     * 未指定・不正値は after として扱う。
     *
     * @param {Object} setting 商品設定
     * @param {jQuery} $target 挿入基準となる要素
     */
    insertForm: function (setting, $target) {
      var html = this.buildFormHtml(setting);
      var method = setting.insert_method;

      if (!$target || $target.length === 0 || $target[0] === undefined || $target[0] === null) {
        this.log("挿入対象が見つからないため、フォーム挿入をスキップ");
        return;
      }

      // 設定された挿入方法でフォームを配置
      if (method === "before") {
        $target.before(html);
      } else if (method === "after") {
        $target.after(html);
      } else if (method === "prepend") {
        $target.prepend(html);
      } else if (method === "append") {
        $target.append(html);
      } else {
        $target.after(html);
      }
    },

    /**
     * フォームのHTML文字列を生成する。
     * ここで生成している要素クラスは CSS / イベント処理と連動しているため、
     * クラス名を変更する場合は CSS と bindEvents 側も同時に修正すること。
     *
     * @param {Object} setting 商品設定
     * @returns {string} 挿入用HTML文字列
     */
    buildFormHtml: function (setting) {
      // 商品ベースターゲット
      var $productBaseTarget = $(setting.product_base_selector).first() || null;

      // 個別設定が空文字の場合はデフォルト文言を使う
      var beforeText = setting.notice_before_form || this.config.defaultNoticeSettings.notice_before_form;
      var afterText = setting.notice_after_form || this.config.defaultNoticeSettings.notice_after_form;

      var html = "";
      html += '<section class="sheet-qty-calc js-sheet-qty-calc" aria-label="必要枚数自動計算フォーム">';
      html += '<h3 class="sheet-qty-calc__title">' + setting.form_title + "</h3>";
      html += '<p class="sheet-qty-calc__notice sheet-qty-calc__notice--before">' + beforeText + "</p>";
      html += '<div class="sheet-qty-calc__row">';
      html += '<label class="sheet-qty-calc__label" for="sheet-qty-calc-width">お部屋の横幅</label>';
      html += '<div class="sheet-qty-calc__input-group">';
      html += '<input class="sheet-qty-calc__input js-sheet-qty-calc-width" id="sheet-qty-calc-width" type="number" min="0" step="0.1" inputmode="decimal" placeholder="例: 350">';
      html += "<span class='sheet-qty-calc__input-unit'>cm</span>";
      html += "</div>"; // .sheet-qty-calc__input-group
      html += "</div>";
      html += '<div class="sheet-qty-calc__row">';
      html += '<label class="sheet-qty-calc__label" for="sheet-qty-calc-depth">お部屋の縦幅</label>';
      html += '<div class="sheet-qty-calc__input-group">';
      html += '<input class="sheet-qty-calc__input js-sheet-qty-calc-depth" id="sheet-qty-calc-depth" type="number" min="0" step="0.1" inputmode="decimal" placeholder="例: 260">';
      html += "<span class='sheet-qty-calc__input-unit'>cm</span>";
      html += "</div>"; // .sheet-qty-calc__input-group
      html += "</div>";
      html += '<div class="sheet-qty-calc__actions">';
      html += '<button type="button" class="btn btn-primary js-sheet-qty-calc-btn">必要枚数を計算する</button>';
      html += "</div>";
      html += '<div class="sheet-qty-calc__row sheet-qty-calc__row--result">';
      html += '<label class="sheet-qty-calc__label" for="sheet-qty-calc-result">必要枚数</label>';
      html += '<div class="sheet-qty-calc__input-group">';
      html += '<input class="sheet-qty-calc__input js-sheet-qty-calc-result" id="sheet-qty-calc-result" type="text" readonly value="">';
      html += "<span class='sheet-qty-calc__input-unit'>枚</span>";
      html += "</div>"; // .sheet-qty-calc__input-group
      html += "</div>";
      html += '<p class="sheet-qty-calc__error js-sheet-qty-calc-error" aria-live="polite"></p>';
      html += '<p class="sheet-qty-calc__notice sheet-qty-calc__notice--after">' + afterText + "</p>";
      html += '<input type="hidden" class="js-sheet-qty-calc-item-width" value="' + this.escapeAttr(setting.product_width) + '">';
      html += '<input type="hidden" class="js-sheet-qty-calc-item-depth" value="' + this.escapeAttr(setting.product_depth) + '">';
      html += "</section>";

      // もし、商品ベースが存在していれば「カートに戻る」ボタンも挿入する
      if ($productBaseTarget && $productBaseTarget.length > 0) {
        html += '<div class="sheet-qty-calc__scroll-to-product-base-btn"><button type="button" class="more xtAc js-sheet-qty-calc-scroll-to-product-base-btn">カートに戻る</button></div>';
      }

      return html;
    },

    /**
     * フォーム操作イベントを登録する。
     * - 計算ボタンクリック
     * - Enterキーによる計算実行
     * - 入力中のエラー表示クリア
     *
     * イベント委譲を使うことで、後から挿入されたフォームにも同じ処理を適用する。
     */
    bindEvents: function () {
      var self = this;

      // スクロールボタンで計算フォームへ移動
      $(document).on("click.sheetQtyCalc", ".js-sheet-qty-calc-scroll-to-tool-btn", function (event) {
        var $target = $(".js-sheet-qty-calc").first();
        event.preventDefault();
        if ($target.length === 0) {
          return;
        }
        self.scrollToElement($target);
      });
      $(document).on("click.sheetQtyCalc", ".js-sheet-qty-calc-scroll-to-product-base-btn", function (event) {
        var $target = $(self.config.productSettings[0].product_base_selector).first();
        event.preventDefault();
        if ($target.length === 0) {
          return;
        }
        self.scrollToElement($target);
      });

      // ボタンクリックで計算
      $(document).on("click.sheetQtyCalc", ".js-sheet-qty-calc-btn", function () {
        var $root = $(this).closest(".js-sheet-qty-calc");
        self.calculateAndRender($root);
      });

      // Enterキーでも計算できるようにする
      $(document).on("keydown.sheetQtyCalc", ".js-sheet-qty-calc-width, .js-sheet-qty-calc-depth", function (event) {
        if (event.keyCode === 13) {
          event.preventDefault();
          $(this).closest(".js-sheet-qty-calc").find(".js-sheet-qty-calc-btn").trigger("click");
        }
      });

      // 入力中は既存エラーを消して再入力しやすくする
      $(document).on("input.sheetQtyCalc", ".js-sheet-qty-calc-width, .js-sheet-qty-calc-depth", function () {
        var $root = $(this).closest(".js-sheet-qty-calc");
        self.clearError($root);
      });
    },

    /**
     * 進行中の再帰スクロールを停止する。
     */
    stopRecursiveScroll: function () {
      if (this._scrollTimerId) {
        clearTimeout(this._scrollTimerId);
        this._scrollTimerId = null;
      }
    },

    /**
     * 残り距離の「半分 + 1px」ずつ進める再帰スクロール。
     * 末尾で自然に減速する挙動（ease-out）を作る。
     *
     * @param {jQuery} $target スクロール先要素
     */
    scrollToElement: function ($target) {
      var self = this;
      var scrollOffset = $(window).width() <= 990 ? 80 : 60; // モバイル対応：画面が狭い時にはスクロール位置を少し上にずらす

      if (!$target || $target.length === 0) {
        return;
      }

      this.stopRecursiveScroll();

      (function stepScroll() {
        var currentTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        var targetTop = Math.max(0, Math.floor($target.offset().top) - scrollOffset);
        var remain = targetTop - currentTop;

        // 1px以内になったら終了
        if (Math.abs(remain) <= 1) {
          window.scrollTo(0, targetTop);
          self._scrollTimerId = null;
          return;
        }

        // 残りの距離に基づく距離 + 1px だけ進める
        var step = Math.floor(Math.abs(remain) * 0.05) + 1;
        if (remain < 0) {
          step = -step;
        }

        // debug
        // console.log(step);

        window.scrollTo(0, currentTop + step);
        self._scrollTimerId = setTimeout(stepScroll, 16);
      })();
    },

    /**
     * 入力値を使って必要枚数を計算し、結果またはエラーを表示する。
     * 計算ルール:
     * - 部屋サイズと商品サイズを長辺/短辺で正規化
     * - ceil(部屋長辺/商品長辺) * ceil(部屋短辺/商品短辺)
     *
     * @param {jQuery} $root 対象フォームのルート要素
     */
    calculateAndRender: function ($root) {
      try {
        // ユーザー入力と商品サイズを取得
        var roomWidth = this.parseNumber($root.find(".js-sheet-qty-calc-width").val());
        var roomDepth = this.parseNumber($root.find(".js-sheet-qty-calc-depth").val());
        var itemWidth = this.parseNumber($root.find(".js-sheet-qty-calc-item-width").val());
        var itemDepth = this.parseNumber($root.find(".js-sheet-qty-calc-item-depth").val());

        // 入力値チェック（1以上の数値のみ有効）
        if (!this.isValidInput(roomWidth, roomDepth)) {
          this.showError($root, this.config.errorMessages.invalid_input);
          this.setResult($root, "");
          return;
        }

        if (!this.isValidInput(itemWidth, itemDepth)) {
          this.showError($root, this.config.errorMessages.calculation_error);
          this.setResult($root, "");
          return;
        }

        // 長辺同士・短辺同士を合わせる計算ルール
        var roomLong = Math.max(roomWidth, roomDepth);
        var roomShort = Math.min(roomWidth, roomDepth);
        var itemLong = Math.max(itemWidth, itemDepth);
        var itemShort = Math.min(itemWidth, itemDepth);

        // 必要枚数 = ceil(部屋長辺/商品長辺) * ceil(部屋短辺/商品短辺)
        var xCount = Math.ceil(roomLong / itemLong);
        var yCount = Math.ceil(roomShort / itemShort);
        var total = xCount * yCount;

        if (!isFinite(total) || total < 1) {
          this.showError($root, this.config.errorMessages.calculation_error);
          this.setResult($root, "");
          return;
        }

        this.clearError($root);
        this.setResult($root, String(total));
      } catch (error) {
        this.log("計算エラー", error);
        this.showError($root, this.config.errorMessages.calculation_error);
        this.setResult($root, "");
      }
    },

    /**
     * 計算結果を結果欄へ反映する。
     * 値がある場合のみ、結果欄へ軽いアニメーションを付与する。
     *
     * @param {jQuery} $root 対象フォームのルート要素
     * @param {string} value 表示する計算結果（空文字ならクリア）
     */
    setResult: function ($root, value) {
      var $result = $root.find(".js-sheet-qty-calc-result");
      $result.val(value);

      // 結果が出たときだけ軽いアニメーションを付与
      $result.removeClass("is-animate");
      if (value !== "") {
        setTimeout(function () {
          $result.addClass("is-animate");
        }, 20);
      }
    },

    /**
     * エラーメッセージを表示する。
     *
     * @param {jQuery} $root 対象フォームのルート要素
     * @param {string} message 表示するエラー文言
     */
    showError: function ($root, message) {
      var $error = $root.find(".js-sheet-qty-calc-error");
      $error.text(message).addClass("is-visible");
    },

    /**
     * エラーメッセージ表示を消去する。
     *
     * @param {jQuery} $root 対象フォームのルート要素
     */
    clearError: function ($root) {
      var $error = $root.find(".js-sheet-qty-calc-error");
      $error.text("").removeClass("is-visible");
    },

    /**
     * 文字列を数値へ変換する。
     * - 先頭/末尾空白を除去
     * - カンマ区切り(例: 1,200)を許容
     * - 空文字は NaN を返す
     *
     * @param {string|number|null|undefined} value 入力値
     * @returns {number} 変換後の数値（変換不可なら NaN）
     */
    parseNumber: function (value) {
      if (typeof value !== "string") {
        value = String(value || "");
      }

      // 3,000 のような入力にも対応できるようカンマを除去
      value = value.replace(/,/g, "").trim();
      if (value === "") {
        return NaN;
      }

      return parseFloat(value);
    },

    /**
     * 計算に使える入力値かを判定する。
     * ルール:
     * - 有限数であること
     * - 幅/奥行きともに 1 以上であること
     *
     * @param {number} width 幅
     * @param {number} depth 奥行き
     * @returns {boolean} 有効なら true
     */
    isValidInput: function (width, depth) {
      if (!isFinite(width) || !isFinite(depth)) {
        return false;
      }

      if (width < 1 || depth < 1) {
        return false;
      }

      return true;
    },

    /**
     * HTMLエスケープ。
     * タイトルや注意文の文字列を安全にHTMLへ埋め込むために使用する。
     *
     * @param {*} text 変換対象
     * @returns {string} エスケープ済み文字列
     */
    escapeHtml: function (text) {
      return String(text).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\"/g, "&quot;").replace(/'/g, "&#39;");
    },

    /**
     * 属性値用エスケープ。
     * 現在は escapeHtml と同等処理だが、用途分離のためメソッドを分けている。
     *
     * @param {*} text 変換対象
     * @returns {string} エスケープ済み属性値
     */
    escapeAttr: function (text) {
      return this.escapeHtml(text);
    },
  };

  SheetQtyCalc.init();
})(jQuery);
